if (!customElements.get('sibling-swatches')) {
  customElements.define(
    'sibling-swatches',
    class SiblingSwatches extends HTMLElement {
      constructor() {
        super();

        this.productBlock = this.closest('[data-product-block]');
        if (!this.productBlock) return;

        this.mainImageContainer = this.productBlock.querySelector('[data-main-image]');
        this.mainImage = this.mainImageContainer?.querySelector('img');
        this.productLinks = this.productBlock.querySelectorAll('[data-grid-link]');
        this.siblingSwatches = this.querySelectorAll('[data-sibling-swatch]');

        this.originalProductUrl = this.getAttribute('data-product-url');
        this.originalProductImage = this.getAttribute('data-product-image');
        this.originalSrcset = this.mainImage?.getAttribute('srcset');
        this.originalSrc = this.mainImage?.getAttribute('src');
      }

      connectedCallback() {
        this.siblingSwatches.forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => this.updateProduct(swatch));
        });

        this.addEventListener('mouseleave', this.resetProduct.bind(this));
      }

      updateProduct(swatch) {
        const siblingImage = swatch.getAttribute('data-sibling-featured-image-url');

        if (siblingImage && this.mainImage) {
          this.mainImage.setAttribute('srcset', siblingImage);
          this.mainImage.setAttribute('src', siblingImage);
        }
      }

      resetProduct() {
        this.productLinks.forEach((link) => link.setAttribute('href', this.originalProductUrl));
        if (this.mainImage) {
          this.mainImage.setAttribute('srcset', this.originalSrcset);
          this.mainImage.setAttribute('src', this.originalSrc);
        }
      }
    }
  );
}
